export default "__VITE_ASSET__6kBFCUvW__"